import Head from "next/head";
import Magazine from "../../../components/collection/magazine";
import { Breakpoint } from "../../../utils/media-query";

const PersonalMagazine = () => {
  const [isDesktop, isTablet, isMobile] = Breakpoint();

  return (
    <>
      <Head>
        <title>Personal Magazine | Aurum Lab</title>
        <meta
          name="description"
          content="Every person is unique and we want to present you something personal. Find your personalised 9K gold necklace from Aurum Lab. Define your own identity with name, initial, or even symbol."
        />
      </Head>
      <main>
        <div className={isDesktop ? "container" : "container-mobile"}>
          <Magazine src="https://e.issuu.com/embed.html?backgroundColorFullscreen=%23ffffff&d=magazine_personal&doAutoflipPages=true&hideIssuuLogo=true&showOtherPublicationsAsSuggestions=true&u=aurumlab" />
        </div>
      </main>
    </>
  );
};
export default PersonalMagazine;
